import { Calendar } from "lucide-react";
import { BaseAppointmentAction, AppointmentActionCategory, UserRole, AppointmentActionContext, AppointmentActionPayload, AppointmentActionResult } from "../core/base-action";
import { fieldActionMessage } from "@/lib/appointment-field-actions";
import { RESCHEDULABLE_STATUSES } from "@/lib/appointment-reschedule";
import { rescheduleAppointment } from "@/services/appointment-reschedule.service";

export class RescheduleAction extends BaseAppointmentAction {
    readonly config = {
        id: "reschedule",
        label: "Reschedule",
        description: "Change appointment date (PMC only)",
        icon: Calendar,
        category: AppointmentActionCategory.SCHEDULING,
        permissions: {
            requiredRole: [UserRole.PMC],
            requiredStatuses: [...RESCHEDULABLE_STATUSES]
        },
        requiresDialog: true,
        variant: "default" as const
    };

    validatePayload(payload?: AppointmentActionPayload): string | null {
        if (!payload?.newDate) {
            return "New date is required for rescheduling";
        }
        return null;
    }

    getDialogComponent(): string {
        return "RescheduleDialog";
    }

    async execute(
        context: AppointmentActionContext,
        payload?: AppointmentActionPayload
    ): Promise<AppointmentActionResult> {
        try {
            const { newDate } = payload || {};
            
            if (!newDate) {
                throw new Error("New date is required for rescheduling");
            }

            if (context.userRole === UserRole.PMC) {
                await rescheduleAppointment(context.appointmentId, newDate);

                return {
                    success: true,
                    message: `Appointment rescheduled to ${newDate}`
                };
            }

            return {
                success: false,
                message: "Vendors cannot reschedule directly. Use 'Request Reschedule' instead."
            };
        } catch (error) {
            return {
                success: false,
                message: fieldActionMessage(error, "Failed to reschedule appointment")
            };
        }
    }
}